import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Box } from '@gemini/core';
import Container from '@/components/structure/Container';
import { useCallToAction, usePrefixI18n, } from '@/contexts/brandConfiguration/hooks';
import Image from '@/components/tools/Image';
import { useTranslation } from '@/hooks/useTranslations';
import List from '@/components/structure/List';
import Redirection from '@/components/Redirection';
import BlockTitle from '@/components/structure/BlockTitle';
export const CallToAction = ({ pageConfiguration, landingType, }) => {
    const { t } = useTranslation();
    const prefix = usePrefixI18n();
    const cta = useCallToAction(pageConfiguration, landingType);
    const locales = `${prefix}${pageConfiguration}.${landingType}`;
    const list = [
        {
            id: `${locales}.calltoaction.list.item1`,
            text: `${locales}.calltoaction.list.item1`,
        },
        {
            id: `${locales}.calltoaction.list.item2`,
            text: `${locales}.calltoaction.list.item2`,
        },
        {
            id: `${locales}.calltoaction.list.item3`,
            text: `${locales}.calltoaction.list.item3`,
        },
    ];
    return (_jsx(Container, { noPaddingMobile: true, children: _jsxs(Box, { width: "100%", borderRadius: {
                'breakpoint.base': 'radius.none',
                'breakpoint.md': 'radius.16',
            }, backgroundColor: "color.surface.brand.primary.default", paddingHorizontal: {
                'breakpoint.base': 'spacing.16',
                'breakpoint.lg': 'spacing.80',
            }, paddingVertical: {
                'breakpoint.base': 'spacing.32',
                'breakpoint.md': 'spacing.64',
                'breakpoint.lg': 'spacing.80',
            }, display: "flex", alignItems: "center", flexDirection: {
                'breakpoint.base': 'column',
                'breakpoint.lg': cta.hasTextLeft ? 'row-reverse' : 'row',
            }, children: [_jsx(Box, { flex: {
                        'breakpoint.base': '1 1 auto',
                        'breakpoint.lg': '0 0 50%',
                        'breakpoint.xl': '0 0 576px',
                    }, children: _jsx(Box, { borderRadius: "radius.16", backgroundColor: {
                            'breakpoint.base': 'color.surface.transparent.default',
                            'breakpoint.lg': 'color.surface.active.hover',
                        }, display: "flex", alignItems: "center", justifyContent: "center", paddingVertical: {
                            'breakpoint.base': 'spacing.none',
                            'breakpoint.lg': 'spacing.40',
                        }, marginBottom: {
                            'breakpoint.base': '-spacing.16',
                            'breakpoint.lg': 'spacing.none',
                        }, children: _jsx(Image, { src: cta.img, alt: t(`iwt.fsrbo.generic.callToAction.img.alt`), width: 351 }) }) }), _jsxs(Box, { borderRadius: "radius.16", backgroundColor: "color.background.constant.white", padding: "spacing.32", marginLeft: {
                        'breakpoint.base': 'spacing.none',
                        'breakpoint.lg': cta.hasTextLeft ? 'spacing.none' : '-spacing.32',
                    }, marginRight: {
                        'breakpoint.base': 'spacing.none',
                        'breakpoint.lg': cta.hasTextLeft ? '-spacing.32' : 'spacing.none',
                    }, zIndex: "zIndex.1", children: [_jsx(Box, { marginBottom: "spacing.8", children: _jsx(BlockTitle, { as: "h2", children: t(`${locales}.calltoaction.title`) }) }), cta.hasSubtitle && (_jsx(Box, { typography: "typography.body.16.regular", marginBottom: "spacing.24", children: t(`${locales}.calltoaction.subtitle`) })), _jsx(List, { items: list, spacing: "spacing.8" }), _jsx(Box, { marginTop: "spacing.32", children: _jsx(Redirection, { pageConfiguration: pageConfiguration, landingType: landingType }) })] })] }) }));
};
